import { clsx } from "clsx";
import { refinancePhoto } from "@/assets/images/offer";
import { Button } from "@/ui/components/Button";
import { Icon } from "@/ui/icons/Icon";
import { useContinueInAppModal } from "@/features/application/components";
import { OfferFaq } from "../../components/OfferFaq";
import { LandingHeading } from "../../components/LandingHeading";
import { LandingReviews } from "../../components/LandingReviews";
import { LandingSteps } from "../../components/LandingSteps";
import { FAQ, REVIEWS, STEPS, USPS } from "./refinanceContent";
import styles from "./RefinanceLandingPage.module.scss";

/**
 * Refinancing, for a preliminary offer refused on income or debt ratio: one
 * credit instead of several. The request itself is made in the app.
 */
export function RefinanceLandingPage() {
  const { open: openContinueInAppModal, modal: continueInAppModal } =
    useContinueInAppModal();

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <section className={styles.heroSection}>
          <div className={styles.hero}>
            <img src={refinancePhoto} alt="" className={styles.heroImage} />
            <div className={styles.heroText}>
              <h1 className={styles.heroTitle}>
                <span>Obține bani în plus</span>
                <span>și o rată mai mică</span>
              </h1>
              <p className={styles.heroSubtitle}>Refinanțează-ți creditele</p>
            </div>
          </div>
        </section>

        <section className={styles.benefits}>
          <div className={styles.headline}>
            <LandingHeading lines={["Nu mai jongla", "cu creditele tale"]} />
            <p className={styles.headlineText}>
              Ai 2, 3 sau chiar 4 rate în fiecare lună?
              <br />
              Adună-le pe toate într-un singur credit.
            </p>
          </div>
          <ul className={styles.usps}>
            {USPS.map((usp) => (
              <li key={usp.label} className={styles.usp}>
                <span className={styles.uspIcon}>
                  <Icon name={usp.icon} size={usp.iconSize ?? 32} />
                </span>
                <p className={styles.uspLabel}>{usp.label}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className={styles.reviews}>
          <LandingHeading lines={["Peste 500 de", "clienți mulțumiți"]} />
          <LandingReviews reviews={REVIEWS} />
        </section>

        <section className={styles.section}>
          <LandingSteps title="E ușor să începi" steps={STEPS} />
        </section>

        <section className={clsx(styles.section, styles.faq)}>
          <h2 className={styles.faqTitle}>Întrebări frecvente</h2>
          <OfferFaq items={FAQ} />
        </section>
      </div>

      <div className={styles.bottomSection}>
        <Button
          trackingId="refinance_landing_request"
          text="Cere refinanțare"
          rightIcon={<Icon name="arrow-right" />}
          onClick={openContinueInAppModal}
          className={styles.requestButton}
        />
        <p className={styles.disclaimer}>
          Trimiterea cererii nu te obligă la nimic.
        </p>
      </div>
      {continueInAppModal}
    </div>
  );
}
